// extracted by mini-css-extract-plugin
export default {"table":"tasksTable_table__8bdnA"};